export default __webpack_public_path__ + "static/media/fastify.6b82b37a.svg";